import { render } from "./RelationshipType.vue?vue&type=template&id=0651e3a0&scoped=true"
import script from "./RelationshipType.vue?vue&type=script&lang=js"
export * from "./RelationshipType.vue?vue&type=script&lang=js"

import "./RelationshipType.vue?vue&type=style&index=0&id=0651e3a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0651e3a0"]])

export default __exports__